import { Grid, Box, Modal } from '@mui/material'
import Button from '../../../../components/Button/Button'
import './CategoryModal.css'
/**
 * Modal komponent der viser mulige pointværdier for en Yatzy kategori
 * @param {boolean} open - Om modalen er åben
 * @param {Function} onClose - Callback funktion der kaldes når modalen lukkes
 * @param {Array} yatzyPoints - Array af Yatzy point kategorier
 * @param {string} category - Den valgte kategori
 * @param {Function} updateScore - Callback funktion der kaldes når en pointværdi vælges
 * @param {number} playerIndex - Index af den aktuelle spiller
 * @param {string} placement - Placering af pointværdien (f.eks. 'upper' eller 'lower')
 * @param {string} gameType - Typen af spil (f.eks. 'fiveDice' eller 'sixDice')
 * @returns {JSX.Element} CategoryModal komponent
 */
const CategoryModal = ({ open, onClose, yatzyPoints, category, updateScore, playerIndex, placement, gameType, onZero, onRemove, correcting = false }) => {
    const points = yatzyPoints.find((point) => point.type === category)

    let shownValues = points?.values
    if (gameType === 'sixDice' && points?.sixDiceValues) {
        shownValues = points?.values.concat(points?.sixDiceValues)
    }
  
    const handleSelect = (value) => {
      updateScore({
        playerIndex,
        scoreType: placement,
        categoryName: category,
        value,
        keepTurn: correcting,
      })
      onClose()
    }
  
    return (
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="category-modal-title"
        aria-describedby="category-modal-description"
      >
        <Box
          className="category-modal"
          sx={{
            width: { xs: '90%', sm: 400 },
            p: { xs: 2, sm: 4 },
          }}
        >
          <h2 id="category-modal-title" className="category-modal-title">
            {correcting ? `Ret ${points?.prettyName || ''}` : points?.prettyName}
          </h2>
          <p id="category-modal-description" className="category-modal-description">
            {points?.description}
          </p>
          <Grid 
            container spacing={2} 
            className="category-modal-grid" 
            sx={{ mt: 2 }}
          >
            <Grid item xs={6}>
              <Button
                title="0"
                onClick={onZero}
                variant="outlined"
                color="secondary"
                className="category-modal-button"
                style={{
                  marginTop: '8px',
                  width: '100%',
                  color: 'var(--secondary-font-color)',
                }}
              />
            </Grid>
            {shownValues?.map((value, index) => (
              <Grid item xs={6} key={index}> 
                <Button 
                  title={value} 
                  onClick={() => handleSelect(value)} 
                  variant="outlined" 
                  color="secondary" 
                  className="category-modal-button"
                  style={{ 
                    marginTop: '8px', 
                    width: '100%',
                    color: 'var(--secondary-font-color)',
                  }} 
                />
              </Grid>
            ))}
          </Grid>
          {correcting ? (
            <button type="button" className="category-modal-remove" onClick={onRemove}>
              Fjern
            </button>
          ) : null}
        </Box>
      </Modal>
    )
}

export default CategoryModal